import React from 'react';
import classNames from 'classnames';
import { VariantOption } from '../../VariantOption';
import { VariantRadio } from './VariantRadio';
import styles from './VariantRadioGroup.module.scss';

export const VariantRadioGroup = ({ options, onChange, selected }: Props) => {
    const className = classNames(styles.options, styles[columnCountFor(options.length)]);
    return (
        <div className={className}>
            {options.map(o => (
                <VariantRadio key={o.value}
                    onClick={() => onChange(o.value)}
                    selected={o.value === selected}
                    {...o} />
            ))}
        </div>
    );
};

type MaxColumnCount = 2 | 3 | 4;
type MaxColumnCountClassName = `options-1/${MaxColumnCount}`;

const columnCountFor = (amountOfOptions: number): MaxColumnCountClassName => {
    if (amountOfOptions % 3 === 0) {
        return 'options-1/3';
    } else if (amountOfOptions === 2) {
        return 'options-1/2';
    } else {
        return 'options-1/4';
    }
};
type Props = {
    selected?: string;
    options: VariantOption[];
    onChange: (value: string) => void;
};